import { Box, Typography, Button } from '@mui/material';

const PP = "'Poppins', sans-serif";

export default function UpdateBanner({ show }) {
    if (!show) return null;

    return (
        <Box sx={{
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000,
            background: 'linear-gradient(90deg, #2563eb 0%, #7c3aed 100%)',
            color: '#fff', px: 2, py: 1.2,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            fontFamily: PP,
        }}>
            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, fontFamily: PP }}>
                New version available — refresh to update.
            </Typography>
            <Button
                size="small"
                variant="contained"
                onClick={async () => {
                    // Defensive: nuke stale service worker registrations so the
                    // refreshed page picks up the latest sw.js immediately.
                    if ('serviceWorker' in navigator) {
                        try {
                            const regs = await navigator.serviceWorker.getRegistrations();
                            await Promise.all(regs.map(r => r.unregister()));
                        } catch { /* ignore */ }
                    }
                    window.location.reload();
                }}
                sx={{
                    background: '#fff', color: '#2563eb', textTransform: 'none',
                    fontWeight: 700, fontFamily: PP, fontSize: '0.78rem',
                    px: 1.5, py: 0.4, minWidth: 0,
                    '&:hover': { background: '#f1f5f9' },
                }}
            >
                Refresh now
            </Button>
        </Box>
    );
}
